import React, { PropTypes } from 'react';
import { pure } from 'recompose';
import { success } from 'plugins/toastr';
import SegmentLoader from 'common/components/SegmentLoader';
import EntityList from 'catalog/components/EntityList';

class NodeSourcePage extends React.Component {
  static propTypes = {
    catalog: PropTypes.string.isRequired,
    entities: PropTypes.array,
    info: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    fetchEntities: PropTypes.func.isRequired,
    createNode: PropTypes.func.isRequired,
    redirectToParent: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.selectEntity = this.selectEntity.bind(this);
  }

  componentWillMount() {
    this.props.fetchEntities();
  }

  selectEntity(entity) {
    const { redirectToParent } = this.props;

    this.props
      .createNode(entity)
      .then(() => redirectToParent())
      .then(() => success('Noeud ajouté avec succès'));
  }

  render() {
    const { entities, info, link } = this.props;
    if (entities) {
      return (
        <EntityList
          entities={entities}
          info={info}
          link={link}
          select={this.selectEntity}
        />
      );
    }

    return <SegmentLoader />;
  }
}

export default pure(NodeSourcePage);



// WEBPACK FOOTER //
// ./src/modules/catalog/pages/NodeSourcePage.js